<template>
  <div v-if="isdisplay" class="pqr-overlay" @click.self="close">
    <div class="pqr-dialog">

      <!-- Header -->
      <div class="pqr-head">
        <div class="pqr-head-left">
          <div class="pqr-head-icon"><i class="ri-camera-line"></i></div>
          <div class="pqr-head-txt">
            <span>Scanner par webcam</span>
            <small>Le QR affiché sur le téléphone client</small>
          </div>
        </div>
        <div class="pqr-head-right">
          <button v-if="torchAvailable"
                  :class="['pqr-torch', { on: torchOn }]"
                  @click="toggleTorch" title="Torche">
            <i :class="torchOn ? 'ri-flashlight-fill' : 'ri-flashlight-line'"></i>
          </button>
          <button class="pqr-close" @click="close" aria-label="Fermer">
            <i class="ri-close-line"></i>
          </button>
        </div>
      </div>

      <!-- Body -->
      <div class="pqr-body">
        <div class="pqr-stage">
          <video ref="video" class="pqr-video" playsinline muted></video>
          <div class="pqr-frame"><span></span><span></span><span></span><span></span></div>

          <div v-if="scanError" class="pqr-state pqr-state-err">
            <i class="ri-camera-off-line"></i>
            <p>Caméra indisponible</p>
            <small>
              Vérifiez l'autorisation du navigateur.
              L'accès caméra exige une connexion sécurisée (HTTPS) ou localhost.
              Utilisez la douchette en attendant.
            </small>
          </div>
          <div v-else-if="!scanning" class="pqr-state">
            <i class="ri-loader-4-line pqr-spin"></i>
            <p>Démarrage de la caméra…</p>
          </div>
        </div>

        <div v-if="erreur" class="pqr-err">
          <i class="ri-error-warning-line"></i>
          <span>{{ erreur }}</span>
        </div>
        <div v-else class="pqr-hint">
          <i class="ri-qr-scan-2-line"></i>
          <span>Placez le QR du téléphone dans le cadre. La lecture est automatique.</span>
        </div>
      </div>

      <!-- Footer -->
      <div class="pqr-foot">
        <button class="pqr-btn-sec" @click="close">Fermer</button>
      </div>

    </div>
  </div>
</template>

<script>
import { parsePayloadScanGo } from "@/service/scangopanier";
import { QrScanner } from "@/service/qrscanner";

export default {
  /* eslint-disable */
  name: "modalscannerqr",

  data() {
    return {
      isdisplay: false,
      scanning: false,
      scanError: false,
      erreur: "",
      torchOn: false,
      torchAvailable: false,
    };
  },

  created() {
    /* Hors de data() : l'objet n'a pas à être réactif, et le rendre réactif
       ferait proxifier le MediaStream et les tracks par Vue. */
    this.scanner = new QrScanner();
  },

  methods: {
    async startScanner() {
      const ok = await this.scanner.demarrer(this.$refs.video, {
        /* Poste de caisse : la webcam fait face au caissier, qui présente le
           téléphone du client devant lui - donc caméra frontale. */
        facingMode: "user",
        formats: ["qr_code"],
        onDecoded: (txt) => this.onDecoded(txt),
      });
      this.scanError = !ok;
      this.scanning = ok;
      this.torchAvailable = this.scanner.torcheDisponible();
    },

    async toggleTorch() {
      this.torchOn = await this.scanner.basculerTorche();
    },

    stopScanner() {
      this.scanner.arreter();
      this.scanning = false;
      this.torchOn = false;
      this.torchAvailable = false;
    },

    /* ══════════ Décodage ══════════ */
    onDecoded(raw) {
      if (!this.scanning) return;

      /* Un QR quelconque (affiche, facture MECeF…) ne doit pas fermer la modal
         en silence : on garde la caméra active et on le dit. */
      if (!parsePayloadScanGo(raw)) {
        this.erreur = "Ce QR n'est pas un panier Scan & Go.";
        return;
      }

      this.stopScanner();
      this.isdisplay = false;
      this.$emit('scanned', raw);
    },

    close() {
      this.stopScanner();
      this.isdisplay = false;
    },

    show() {
      this.scanError = false;
      this.erreur = "";
      this.isdisplay = true;
      /* La balise <video> n'existe qu'une fois isdisplay passé à true. */
      this.$nextTick(() => this.startScanner());
    },
  },

  beforeUnmount() {
    this.stopScanner();
  },

  mounted() {},
};
</script>

<style scoped>
/* ── Overlay ── */
.pqr-overlay {
  position: fixed; inset: 0; z-index: 10030;
  background: rgba(0, 0, 0, .55);
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
  font-family: 'Segoe UI', system-ui, sans-serif;
}

/* ── Dialog ── */
.pqr-dialog {
  background: var(--surface); border: 1px solid var(--border);
  border-radius: 14px; width: min(520px, 100%);
  display: flex; flex-direction: column; overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, .45);
  animation: pqr-in .2s cubic-bezier(.4, 0, .2, 1);
}
@keyframes pqr-in {
  from { opacity: 0; transform: scale(.93) translateY(10px); }
  to   { opacity: 1; transform: none; }
}

/* ── Header ── */
.pqr-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 18px; border-bottom: 1px solid var(--border); flex-shrink: 0;
}
.pqr-head-left { display: flex; align-items: center; gap: 10px; }
.pqr-head-icon {
  width: 34px; height: 34px; border-radius: 9px; flex-shrink: 0;
  background: color-mix(in srgb, var(--accent) 15%, transparent);
  color: var(--accent); font-size: 17px;
  display: flex; align-items: center; justify-content: center;
}
.pqr-head-txt { display: flex; flex-direction: column; line-height: 1.3; }
.pqr-head-txt span { font-size: 14px; font-weight: 800; color: var(--text); }
.pqr-head-txt small { font-size: 11px; color: var(--text2); }
.pqr-head-right { display: flex; align-items: center; gap: 6px; }
.pqr-torch {
  width: 32px; height: 32px; border-radius: 8px;
  border: 1px solid var(--border); background: var(--surface2);
  color: var(--text2); font-size: 15px; cursor: pointer;
  display: flex; align-items: center; justify-content: center; transition: all .12s;
}
.pqr-torch.on { background: var(--amber); border-color: var(--amber); color: #fff; }
.pqr-close {
  background: none; border: none; color: var(--text2); font-size: 20px;
  cursor: pointer; line-height: 1; padding: 4px; border-radius: 6px;
  transition: color .12s;
}
.pqr-close:hover { color: var(--red); }

/* ── Body ── */
.pqr-body { padding: 16px 18px; display: flex; flex-direction: column; gap: 10px; }

.pqr-stage {
  position: relative; width: 100%; aspect-ratio: 4 / 3;
  background: #000; border-radius: 12px; overflow: hidden;
  border: 1px solid var(--border);
}
.pqr-video { width: 100%; height: 100%; object-fit: cover; display: block; }

/* Cadre de visée */
.pqr-frame { position: absolute; inset: 16%; pointer-events: none; }
.pqr-frame span {
  position: absolute; width: 26px; height: 26px;
  border: 3px solid var(--accent);
}
.pqr-frame span:nth-child(1) { top: 0; left: 0; border-right: none; border-bottom: none; border-radius: 8px 0 0 0; }
.pqr-frame span:nth-child(2) { top: 0; right: 0; border-left: none; border-bottom: none; border-radius: 0 8px 0 0; }
.pqr-frame span:nth-child(3) { bottom: 0; left: 0; border-right: none; border-top: none; border-radius: 0 0 0 8px; }
.pqr-frame span:nth-child(4) { bottom: 0; right: 0; border-left: none; border-top: none; border-radius: 0 0 8px 0; }

.pqr-state {
  position: absolute; inset: 0;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 6px; text-align: center; padding: 20px;
  background: rgba(0, 0, 0, .72); color: #fff;
}
.pqr-state i { font-size: 34px; opacity: .85; }
.pqr-state p { font-size: 13px; font-weight: 700; margin: 0; }
.pqr-state small { font-size: 11px; opacity: .7; line-height: 1.45; max-width: 300px; }
.pqr-state-err i { color: var(--red); }
.pqr-spin { display: inline-block; animation: pqr-spin .8s linear infinite; }
@keyframes pqr-spin { to { transform: rotate(360deg); } }

.pqr-hint, .pqr-err {
  display: flex; align-items: center; gap: 8px;
  border-radius: 9px; padding: 9px 12px;
  font-size: 11.5px; line-height: 1.45;
}
.pqr-hint {
  background: var(--surface2); border: 1px solid var(--border); color: var(--text2);
}
.pqr-hint i { font-size: 16px; color: var(--accent); flex-shrink: 0; }
.pqr-err {
  background: color-mix(in srgb, var(--red) 12%, transparent);
  border: 1px solid var(--red); color: var(--red); font-weight: 600;
}
.pqr-err i { font-size: 15px; flex-shrink: 0; }

/* ── Footer ── */
.pqr-foot {
  display: flex; gap: 8px; justify-content: flex-end;
  padding: 14px 18px; border-top: 1px solid var(--border); flex-shrink: 0;
}
.pqr-btn-sec {
  padding: 9px 16px; border-radius: 8px;
  background: var(--surface2); border: 1px solid var(--border);
  color: var(--text2); font-size: 13px; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: all .12s;
}
.pqr-btn-sec:hover { border-color: var(--red); color: var(--red); }

/* ── Mobile bottom-sheet ── */
@media (max-width: 640px) {
  .pqr-overlay { align-items: flex-end; padding: 0; }
  .pqr-dialog {
    width: 100%; border-radius: 16px 16px 0 0;
    animation: pqr-slide-up .25s cubic-bezier(.4, 0, .2, 1);
  }
}
@keyframes pqr-slide-up {
  from { transform: translateY(100%); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}
</style>
